export default __webpack_public_path__ + "static/media/Path3429.6baff5af.svg";